export default function scrollToTop() {
	const scrollTopBtn = document.querySelector('.footer__scroll-top');
	if (scrollTopBtn) {
	  scrollTopBtn.addEventListener('click', function() {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	  });
	}
  }
